import { useMemo } from 'react'

//* Components
import { Page, Container, Icon, Text, Input, FormContainer } from 'components/common'
import { Collapse } from 'antd';
const { Panel } = Collapse;

//* Style
import FAQStyle from 'styles/pages/FAQStyle'

const data = {
    questions: [
        {
            title: '1. Why should one even use Oplos?',
            text: 'We’ve created this platform to let everyone share their opinions about any issue concerning anything. We’re an open-minded community giving high priority to each and every individual.'
        },
        {
            title: '2. Can I have private debates on Oplos?',
            text: 'Yes, while creating the debate in the setting page you can choose to have private debate, which will only be accessible and visible for the people you’ve chosen.'
        },
        {
            title: '3.	Is Oplos debating free?',
            text: 'Yes, we don’t have any limitations on anything.'
        },
        {
            title: '4.	Can I have a corporate profile on Oplos?',
            text: '4.  Corporate profiles with special functionality will be available in the near future.'
        }
    ]
}

const Faq = () => {
    const storeQuestions = useMemo(() => {
        return data.questions.map((i, k) => (
            <Panel header={<Text tag={'h5'} className='h5 PopSemi' text={i.title} />} key={k + 1}>
                <Text tag={'h5'} className='h5 PopReg' text={i.text} />
            </Panel>
        ))
    }, [])

    return (
        <FAQStyle>
            <Page className={'faq'}>
                <Container>
                    <div className='top-section flexBox alignMiddle alignCenter'>
                        <div className='content flexBoxColumn'>
                            <Text tag={'h2'} className='h2 NewYork white' text='How can we help you?' />
                            {/* <FormContainer>
                                <div className='search-cont'>
                                    <Icon className={'op-search'} />
                                    <Input placeholder="Search by topic, term or anything else" enterButton="Search" size="large" />
                                </div>
                            </FormContainer> */}
                        </div>
                    </div>
                    <div className='asked'>
                        <Text tag={'p'} className={'h11 PopSemi'} text={'Frequently asked questions'} />
                        <Collapse defaultActiveKey={['1']}>
                            {storeQuestions}
                        </Collapse>
                    </div>
                </Container>
            </Page>
        </FAQStyle>
    )
}

export default Faq
